import { derived } from "svelte/store";
import { url } from "../url";
export const NON_SEARCH_PARAMS = ['p', 'size', 'location'];
export const WHERE_SEARCH_PARAMS = ['shapeId', 'esriMagicKey', 'place', 'radius', 'bbox'];
export const SearchState = derived(url, $url => {
    const pathElements = $url.pathname.split('/');
    const datasetIndex = pathElements.findIndex(element => element === 'dataset');
    const newParams = new URLSearchParams();
    Array.from([...$url.searchParams.entries()]).flatMap(([key, value]) => {
        if (!NON_SEARCH_PARAMS.includes(key)) {
            if (value) {
                newParams.append(key, value);
            }
        }
    });
    const newSearchState = {
        pageNum: Number($url.searchParams.get('p')) || 1,
        pageSize: Number($url.searchParams.get('size')) || 10,
        selectedDatasetId: datasetIndex > 0 ? pathElements[datasetIndex + 1] : null,
        params: newParams
    };
    return newSearchState;
});
